module.exports = __webpack_public_path__ + "img/xiong.925a138e.png";